module.exports = __webpack_public_path__ + "6d027182f3d6d26cec20efd3c1c478fc.jpg"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/labels/products/burger.jpg
 ** module id = 420
 ** module chunks = 0
 **/